import React, { FC } from 'react'
import { Box, makeStyles, BoxProps as MuiBoxProps, Theme } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { SidebarLabel } from './SidebarLabel'

interface ISidebarItemProps {
  /**
   * @default 'black'
   */
  textColor?: keyof typeof brandColors
  BoxProps?: MuiBoxProps
  icon?: JSX.Element
  label?: string
}

const useSidebarItemStyles = makeStyles<Theme, Required<Pick<ISidebarItemProps, 'textColor'>>>(
  theme => ({
    inner: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: theme.spacing(1.5),
    },
    text: {
      flex: '0 0 100%',
      display: 'block',
      color: props => brandColors[props.textColor],
    },
  })
)

export const SidebarItem: FC<ISidebarItemProps> = ({
  icon,
  children,
  label,
  BoxProps = {
    pt: 2,
    pl: 0,
    pr: 0,
    pb: 0,
  },
  textColor = 'black',
}) => {
  const classes = useSidebarItemStyles({ textColor })
  return (
    <Box {...BoxProps}>
      {label && <SidebarLabel>{label}</SidebarLabel>}
      <Box className={classes.inner}>
        {icon && <Box className={classes.icon}>{icon}</Box>}
        <Box className={classes.text}>{children}</Box>
      </Box>
    </Box>
  )
}
